const ITEMS = [
  "PERSONAL INTELLIGENCE",
  "DIGITAL TWIN",
  "CONTINUOUS OBSERVATION",
  "WORLD MODEL OF ONE",
  "PRECISION HEALTH",
  "SIGNAL → MODEL → PLAN",
];

const Marquee = () => (
  <div
    data-testid="marquee"
    className="relative z-10 overflow-hidden border-y border-line/50 py-5"
  >
    <div className="marquee-track flex w-max items-center">
      {[...ITEMS, ...ITEMS, ...ITEMS, ...ITEMS].map((item, i) => (
        <span
          key={i}
          className="flex items-center font-mono text-[11px] tracking-[0.3em] text-ash"
        >
          <span className="px-8">{item}</span>
          <span className="h-1 w-1 rounded-full bg-white/20" />
        </span>
      ))}
    </div>
  </div>
);

export default Marquee;
